
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cleartax.in/ifsc-code",
      function () {
        return require("private-next-pages/cleartax.in/ifsc-code/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cleartax.in/ifsc-code"])
      });
    }
  